import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";

@inheritSerialization(BaseUUIDEntity)
export default class PindahPendidikan extends BaseUUIDEntity {

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public from_formal: string = "";

    @serialize
    @deserialize
    public from_non_formal: string = "";

    @serialize
    @deserialize
    public to_formal: string = "";

    @serialize
    @deserialize
    public to_non_formal: string = "";

}
